





















































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseColorpicker from "@/app/shared/components/base/BaseColorpicker.vue";
import BaseInputColor from "@/app/shared/components/base/BaseInputColor.vue";
import BaseInputStepping from "@/app/shared/components/base/BaseInputStepping.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseLabeledSwitch from "@/app/shared/components/base/BaseLabeledSwitch.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseTooltipIcon from "@/app/shared/components/base/BaseTooltipIcon.vue";
import { Item } from "../../../models/classes/Item";
import { PreviewParameters } from "../../../models/classes/PreviewParameters";
import { EndCardAPI } from "@/app/modules/work/services/EndCardAPI";
import { throttle } from "@/app/shared/utils/utils"
import {version} from "fabric/fabric-impl";

export default Vue.extend({
  name: "SizeController",
  components: {
    BaseButton,
    BaseColorpicker,
    BaseInputColor,
    BaseInputStepping,
    BaseInput,
    BaseLabeledSwitch,
    BaseCheckbox,
    BaseSimpleSlider,
    BaseTooltipIcon,
  },
  data: function () {
    return {
      imageFiles: [],
      cachedClientX: null,
    };
  },
  props: {
    isMultiSelectMode: {
      type: Boolean,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    isLoadingPackshot: function () {
      if (!this.previewItem.currentVariation.checked) {
        return this.previewItem.currentVariation.isLoadingPackshot;
      } else {
        return this.items.some((i) => {
          return i.variations.some((v) => {
            return v.checked && v.isLoadingPackshot;
          });
        });
      }
    },
    minVideoResolution: function () {
      return PreviewParameters.CONSTANT_MIN_VIDEO_RESOLUTION;
    },
    maxVideoResolution: function () {
      return PreviewParameters.CONSTANT_MAX_VIDEO_RESOLUTION;
    },
    sizeButtons: function () {
      return this.previewItem.getVideoSizes(
        this.previewItem.isForSlice ? null : this.previewItem.inputSize.name,
        !this.previewItem.isForSlice
      );
    },
    isOriginalSize: function () {
      return this.previewItem.currentVariation.currentSize.title === "Original";
    },
    isEditCustomSizeEnable: function () {
      let isSomeForSlicer = this.items.some(
        (i) => i.variations.some((v) => v.checked) && i.isForSlice
      );
      return !this.previewItem.currentVariation.checked || !isSomeForSlicer;
    },
    keymap: function () {
      return {
        left: this.onClickCropButton.bind(this, "move-left"),
        right: this.onClickCropButton.bind(this, "move-right"),
        up: this.onClickCropButton.bind(this, "move-up"),
        down: this.onClickCropButton.bind(this, "move-down"),
        //"+": this.onClickZoomButton.bind(this, "zoom-in"),
        "=": this.onClickZoomButton.bind(this, "zoom-in"),
        "-": this.onClickZoomButton.bind(this, "zoom-out"),
      };
    },
    wasShownAndClosedNoticeSharpen: function () {
      return this.$store.getters.getWasShownAndClosedNoticeSharpen;
    },
    shadowConfiguration: function () {
      return this.$store.getters.getShadowForCurrentVariation
    },
    shadowOpacity: function() {
      if (this.shadowConfiguration) {
        let value = (this.shadowConfiguration.opacity * 100).toFixed(0)
        return +value
      }
      return 0
    },
    shadowVisibility: function() {
      return this.shadowConfiguration.visible
    },
    currentPreset: function() {
      return this.previewItem.currentVariation.preset?.name
    },
    shadowColor: function() {
      if (this.shadowConfiguration) {
        return this.shadowConfiguration.color
      }
      return '#000'
    },
  },
  created() {
    $eventsBus.$on("shiftVideoByOneStep", (buttonName, isDrag) => {
      this.onClickCropButton(buttonName, isDrag);
    });
  },
  mounted() {
    document.addEventListener('mouseup', () => {
      document.body.classList.remove('col-resize')
      document.removeEventListener('mousemove', this.recalcShadowOpacityWithThrottle)
    })
  },
  watch: {
    /*     previewItem: function () {
      this.sizeButtons = this.previewItem.getVideoSizes(
        this.previewItem.isForSlice ? null : this.previewItem.inputSize.name,
        !this.previewItem.isForSlice
      );
    }, */
  },
  methods: {
    // drop-shadow:
    shadowColorChangeHandler(event) {
      this.$store.commit("addNewStateToHistory")
      this.$store.commit('changeShadowColor', event.target.value)
    },
    shadowVisibilityChangeHandler(event) {
      this.$store.commit("addNewStateToHistory")
      event.target.parentElement.classList.toggle('svg-shadow__label--eye-closed')
      this.$store.commit('changeShadowVisibility')
    },
    shadowOpacityMousedownHandler(event) {
      this.$store.commit("addNewStateToHistory")
      this.cachedClientX = null
      if (this.shadowConfiguration.visible) {
        document.body.classList.add('col-resize')
        document.addEventListener('mousemove', this.recalcShadowOpacityWithThrottle)
      } else {
        console.warn('Вы же не пытаетесь изменить значение несуществующей тени, верно?')
      }
    },
    recalcShadowOpacityWithThrottle: throttle(function(event) {
      // Отсекаем отрицательные координаты
      if (event.clientX < 0) return

      // Проверяем кеш
      if (!this.cachedClientX) {
        this.cachedClientX = event.clientX
        return
      }

      // Считаем дельту, для динамической чувствительности инпута (осторожно, портянка)
      let delta = 0
      if (Math.abs(this.cachedClientX - event.clientX) >= 100) {
        delta = 40
      } else if (Math.abs(this.cachedClientX - event.clientX) >= 75) {
        delta = 20
      } else if (Math.abs(this.cachedClientX - event.clientX) >= 50) {
        delta = 10
      } else if (Math.abs(this.cachedClientX - event.clientX) >= 25) {
        delta = 5
      } else {
        delta = 1
      }

      if (event.clientX < this.cachedClientX) {
        this.$store.commit('changeShadowOpacityByStep', {
          ascending: false,
          value: delta,
        })
        this.cachedClientX = event.clientX
        return
      }

      if (event.clientX > this.cachedClientX) {
        this.$store.commit('changeShadowOpacityByStep', {
          ascending: true,
          value: delta,
        })
        this.cachedClientX = event.clientX
        return;
      }
    }, 100),
    shadowOpacityClickHandler(event) {
      event.target.focus()
    },
    shadowOpacityInputHandler(event) {
      if (event.target.value > 100 || event.target.value < 0) {
        console.warn('Недопустимое значение тени')
        event.target.value = this.shadowConfiguration.opacity * 100
        return
      }
      if (event.target.value === '') {
        this.$store.commit('changeShadowOpacityByNumber', 0)
        event.target.value = 0
        return
      }
      this.$store.commit('changeShadowOpacityByNumber', event.target.value)
    },

    setIsShowNoticeSharpen(variation) {
      if (
        variation.previewParameters.userOuterVideoResolutionsDifference > 1 &&
        !this.wasShownAndClosedNoticeSharpen
      ) {
        variation.isShowNoticeSharpen = true;
      }
    },
    onChangePreset(preset) {
      let presetName = preset.name;
      if (this.previewItem.currentVariation.preset.name === presetName) {
        return;
      }
      this.previewItem.currentVariation.preset = Item.presets.find(
        (preset) => preset.name === presetName
      );
      this.changeCheckedItems({
        isPreset: true,
      });
      if (presetName === "image") {
        this.onChooseImagePreset();
      }
      this.previewItem.currentVariation.clearShiftsAndZoom();

      if (presetName === 'crop' && this.shadowConfiguration.visible) {
        this.$store.commit('changeShadowVisibility')
      }
    },
    onChooseImagePreset() {
      this.axios
        .post(
          "/bg/getBG",
          {
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (
            this.imageFiles.map((f) => f.id).sort() !==
            response.data.map((f) => f.id).sort()
          ) {
            this.imageFiles = [];
            response.data.forEach((file) => {
              this.imageFiles.push(file);
            });
          }
          let defaultFile = this.imageFiles.find((f) => f.id === 1);
          let indexToDelete = this.imageFiles.indexOf(defaultFile);
          this.imageFiles.splice(indexToDelete, 1);
          this.imageFiles.unshift(defaultFile);

          if (!this.previewItem.currentVariation.backgroundImage.id) {
            this.previewItem.currentVariation.backgroundImage = {
              ...defaultFile,
            };
          }
          this.changeCheckedItems({
            isImage: true,
          });
        });
    },
    async onChangeSize(size) {
      /*       this.previewItem.currentVariation.currentSize = Item.videoSizes.find(
        (size) => size.name === sizeName
	  ); */
      if (!this.checkAllItemsVariationsPackshotsHasThisSize(size)) {
        return;
      }
      await this.changeAllItemsVariationsTemplatePackshot(size.name)
        .then(() => {
          this.previewItem.currentVariation.currentSize = size;
          if (this.isOriginalSize) {
            this.previewItem.currentVariation.preset = Item.presets.find(
              (preset) => preset.name === "color"
            );
            this.changeCheckedItems({
              isPreset: true,
            });
          }
          setTimeout(() => {
            this.previewItem.currentVariation.previewParameters.checkAndUpdateUserOuterVideoResolutions();
            this.previewItem.currentVariation.recalcFileOutputParameters();
          }, 10);

          this.previewItem.currentVariation.clearShiftsAndZoom();
          this.changeCheckedItems({
            isSize: true,
          });

          setTimeout(() => {
            this.$store.commit("addNewStateToHistory");
          }, 50);
        })
        .catch(() => {
          return;
        });
      if (
        this.$store.getters.getOpenedGridType === 'tiktok'
        || this.$store.getters.getOpenedGridType === 'instagram-stories'
      ) {
        this.$store.commit('changeOpenedGridType', null)
      }
      if (size.title === 'Original' && this.shadowConfiguration.visible) {
        this.$store.commit('changeShadowVisibility')
      }
    },
    async changeAllItemsVariationsTemplatePackshot(size) {
      let variationsCount = 0;
      let variationsWithBadEndCard = [];
      if (!this.previewItem.currentVariation.checked) {
        if (
          this.previewItem.currentVariation.endCard.packshot &&
          this.previewItem.currentVariation.endCard.getType() ===
            "template-default"
        )
          await this.changeTemplatePackhot(
            this.previewItem.currentVariation,
            this.previewItem.currentVariation.endCard.packshot,
            size
          ).catch((e) => {
            variationsCount++;
            variationsWithBadEndCard.push(this.previewItem.currentVariation);
          });
      } else {
        let variations = [];
        this.items.forEach((i) => {
          i.variations.forEach((v) => {
            if (
              v.checked &&
              v.endCard.packshot &&
              v.endCard.getType() === "template-default"
            ) {
              variations = [v, ...variations];
            }
          });
        });
        if (variations.length > 0) {
          await Promise.all(
            variations.map(async (v) => {
              await this.changeTemplatePackhot(v, v.endCard.packshot, size)
                .then()
                .catch((e) => {
                  variationsCount++;
                  variationsWithBadEndCard.push(v);
                });
            })
          );
        }
      }
      if (variationsWithBadEndCard.length > 0) {
        const message =
          "In " +
          variationsCount +
          " variations, the End Card will be removed. Continue?";
        let isDelete = confirm(message);
        if (isDelete) {
          variationsWithBadEndCard.forEach((v) => {
            v.endCard.packshot = null;
            v.recalcFileOutputParameters();
          });
        } else {
          return Promise.reject();
        }
      }
    },
    async changeTemplatePackhot(variation, selectedPackshot, size) {
      variation.isLoadingPackshot = true;

      await EndCardAPI.getTemplatePackhot(selectedPackshot, size)
        .then((response) => {
          const { json } = response.data;
          variation.endCard.packshot.json = json;
          variation.endCard.applyModifiedValuesForNewSize();
        })
        .finally(() => {
          variation.isLoadingPackshot = false;
        });
    },
    checkAllItemsVariationsPackshotsHasThisSize(size) {
      let itemsCount = 0;
      let variationsCount = 0;
      let variationsWithBadEndCard = [];
      let message = "";
      if (this.previewItem.currentVariation.checked) {
        this.items.forEach((item) => {
          let isHasEndCardsToDelete = false;
          item.variations.forEach((variation) => {
            if (!variation.checked) {
              return;
            }
            if (
              !variation.endCard.packshot ||
              variation.endCard.packshot?.list[size.name.toLowerCase()]
            ) {
              return;
            } else {
              isHasEndCardsToDelete = true;
              variationsCount++;
              variationsWithBadEndCard.push(variation);
            }
          });
          itemsCount += isHasEndCardsToDelete ? 1 : 0;
        });
        message =
          "In " +
          itemsCount +
          " video items in " +
          variationsCount +
          " variations, the End Card will be removed. Continue?";
      } else {
        if (
          this.previewItem.currentVariation.endCard.packshot &&
          !this.previewItem.currentVariation.endCard.packshot.list[
            size.name.toLowerCase()
          ]
        ) {
          itemsCount++;
          variationsCount++;
          variationsWithBadEndCard.push(this.previewItem.currentVariation);
          message = "In this variation the End Card will be removed. Continue?";
        }
      }
      if (itemsCount > 0) {
        let isDelete = confirm(message);
        if (isDelete) {
          //delete
          variationsWithBadEndCard.forEach((v) => {
            v.endCard.packshot = null;
            v.recalcFileOutputParameters();
          });
        }
        return isDelete;
      } else {
        return true;
      }
    },
    changeCustomSizeForCheckedVariations(width, height) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }

      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }
          v.recalcOuterVideoResolutions();
          if (width !== null) {
            this.changeUserOuterVideoResolutionX(v, width, false);
          }
          if (height !== null) {
            this.changeUserOuterVideoResolutionY(v, height, false);
          }
        });
      });
    },
    resetSharpEnabled(variation) {
      if (
        variation.previewParameters.userOuterVideoResolutionsDifference <= 1
      ) {
        variation.isSharpEnabled = false;
      }
    },
    changeUserOuterVideoResolutionX(variation, sizeNumber, isChangeChacked = true) {
      variation.previewParameters.userOuterVideoResolutionsDifference =
        sizeNumber / variation.previewParameters.outerVideoResolutionX;

      this.resetSharpEnabled(variation);
      setTimeout(() => {
        variation.previewParameters.checkAndUpdateUserOuterVideoResolutions();
        variation.recalcFileOutputParameters();
        if (isChangeChacked) {
          this.changeCustomSizeForCheckedVariations(sizeNumber, null);
          this.$store.commit("addNewStateToHistory");
        }
      }, 10);
    },
    changeUserOuterVideoResolutionY(variation, sizeNumber, isChangeChacked = true) {
      variation.previewParameters.userOuterVideoResolutionsDifference =
        sizeNumber / variation.previewParameters.outerVideoResolutionY;

      this.resetSharpEnabled(variation);
      setTimeout(() => {
        variation.previewParameters.checkAndUpdateUserOuterVideoResolutions();
        variation.recalcFileOutputParameters();
        if (isChangeChacked) {
          this.changeCustomSizeForCheckedVariations(null, sizeNumber);
          this.$store.commit("addNewStateToHistory");
        }
      }, 10);
    },
    incrementCustomSize(isWidth) {
      let potentialWidth =
        this.previewItem.currentVariation.previewParameters
          .outerVideoResolutionX *
        this.previewItem.currentVariation.previewParameters
          .userOuterVideoResolutionsDifference;
      let potentialHeight =
        this.previewItem.currentVariation.previewParameters
          .outerVideoResolutionY *
        this.previewItem.currentVariation.previewParameters
          .userOuterVideoResolutionsDifference;
      if (
        potentialWidth < this.maxVideoResolution &&
        potentialHeight < this.maxVideoResolution
      ) {
        potentialWidth++;
        potentialHeight++;
        this.previewItem.currentVariation.previewParameters.userOuterVideoResolutionsDifference =
          potentialHeight /
          this.previewItem.currentVariation.previewParameters
            .outerVideoResolutionY;

        this.resetSharpEnabled(this.previewItem.currentVariation);
        this.previewItem.currentVariation.previewParameters.checkAndUpdateUserOuterVideoResolutions();
        this.previewItem.currentVariation.recalcFileOutputParameters();
      }

      setTimeout(() => {
        this.changeCustomSizeForCheckedVariations(
          isWidth ? potentialWidth : null,
          isWidth ? null : potentialHeight
        );
        this.$store.commit("addNewStateToHistory");
      }, 10);
    },
    decrementCustomSize(isWidth) {
      let potentialWidth =
        this.previewItem.currentVariation.previewParameters
          .outerVideoResolutionX *
        this.previewItem.currentVariation.previewParameters
          .userOuterVideoResolutionsDifference;
      let potentialHeight =
        this.previewItem.currentVariation.previewParameters
          .outerVideoResolutionY *
        this.previewItem.currentVariation.previewParameters
          .userOuterVideoResolutionsDifference;
      if (
        potentialWidth > this.minVideoResolution &&
        potentialHeight > this.minVideoResolution
      ) {
        potentialWidth--;
        potentialHeight--;
        this.previewItem.currentVariation.previewParameters.userOuterVideoResolutionsDifference =
          potentialHeight /
          this.previewItem.currentVariation.previewParameters
            .outerVideoResolutionY;

        this.resetSharpEnabled(this.previewItem.currentVariation);
        this.previewItem.currentVariation.previewParameters.checkAndUpdateUserOuterVideoResolutions();
        this.previewItem.currentVariation.recalcFileOutputParameters();
      }
      setTimeout(() => {
        this.changeCustomSizeForCheckedVariations(
          isWidth ? potentialWidth : null,
          isWidth ? null : potentialHeight
        );
        this.$store.commit("addNewStateToHistory");
      }, 10);
    },
    onClickCropButton(buttonName, isDrag = false) {
      if (this.isVideoShiftsDisabled(this.previewItem.currentVariation)) {
        return;
      }
      let itemParameters = this.previewItem.currentVariation.previewParameters;
      switch (buttonName) {
        case "move-up":
          if (
            itemParameters.displayVerticalShift ===
            itemParameters.displayMaxVerticalShift
          ) {
            return;
          }
          itemParameters.displayVerticalShift++;
          itemParameters.verticalShift =
            this.previewItem.currentVariation.getShiftByDisplayShift(false);
          this.previewItem.currentVariation.shiftVideoPreview(
            null,
            itemParameters.verticalShift
          );
          break;
        case "move-down":
          if (
            itemParameters.displayVerticalShift ===
            itemParameters.displayMinVerticalShift
          ) {
            return;
          }
          itemParameters.displayVerticalShift--;
          itemParameters.verticalShift =
            this.previewItem.currentVariation.getShiftByDisplayShift(false);
          this.previewItem.currentVariation.shiftVideoPreview(
            null,
            itemParameters.verticalShift
          );
          break;
        case "move-right":
          if (
            itemParameters.displayHorizontalShift ===
            itemParameters.displayMinHorizontalShift
          ) {
            return;
          }
          itemParameters.displayHorizontalShift--;
          itemParameters.horizontalShift =
            this.previewItem.currentVariation.getShiftByDisplayShift(true);
          this.previewItem.currentVariation.shiftVideoPreview(
            itemParameters.horizontalShift,
            null
          );
          break;
        case "move-left":
          if (
            itemParameters.displayHorizontalShift ===
            itemParameters.displayMaxHorizontalShift
          ) {
            return;
          }
          itemParameters.displayHorizontalShift++;

          itemParameters.horizontalShift =
            this.previewItem.currentVariation.getShiftByDisplayShift(true);
          this.previewItem.currentVariation.shiftVideoPreview(
            itemParameters.horizontalShift,
            null
          );
          break;
        default:
      }
      this.changeCheckedItems({
        isShift: true,
      });

      if (!isDrag) {
        this.$store.commit("addNewStateToHistory");
      }
    },
    onInputCropCounter(direction, value) {
      let previewParameters =
        this.previewItem.currentVariation.previewParameters;
      var isHorizontal = direction === "x";
      //previewParameters.maxVerticalShift === 0 ? true : false;

      if (isHorizontal) {
        this.previewItem.currentVariation.previewParameters.displayHorizontalShift =
          value;
        previewParameters.horizontalShift =
          this.previewItem.currentVariation.getShiftByDisplayShift(true);
        this.previewItem.currentVariation.shiftVideoPreview(
          previewParameters.horizontalShift,
          null
        );
      } else {
        this.previewItem.currentVariation.previewParameters.displayVerticalShift =
          value;
        previewParameters.verticalShift =
          this.previewItem.currentVariation.getShiftByDisplayShift(false);
        this.previewItem.currentVariation.shiftVideoPreview(
          null,
          previewParameters.verticalShift
        );
      }
      this.changeCheckedItems({
        isShift: true,
      });
      this.$store.commit("addNewStateToHistory");
    },
    onClickZoomButton(buttonName) {
      let itemParameters = this.previewItem.currentVariation.previewParameters;
      let minZoom = this.isMultiSelectMode ? 100 : itemParameters.minZoom;
      let maxZoom = this.isMultiSelectMode ? 200 : itemParameters.maxZoom;
      switch (buttonName) {
        case "zoom-out":
          if (
            itemParameters.zoom <= minZoom ||
            itemParameters.zoom - 10 <= minZoom
          ) {
            itemParameters.zoom = minZoom;
          } else {
            itemParameters.zoom -= 10;
          }
          break;
        case "zoom-in":
          if (
            itemParameters.zoom >= maxZoom ||
            itemParameters.zoom + 10 >= maxZoom
          ) {
            itemParameters.zoom = maxZoom;
          } else {
            itemParameters.zoom += 10;
          }
          break;
        default:
      }
      this.changeCheckedItems({
        isZoom: true,
      });
      this.$store.commit("addNewStateToHistory");
    },
    flipHorizontal() {
      this.previewItem.currentVariation.flipHorizontal =
        !this.previewItem.currentVariation.flipHorizontal;
      this.changeCheckedItems({
        isFlip: true,
      });
      this.$store.commit("addNewStateToHistory");
    },
    flipVertical() {
      this.previewItem.currentVariation.flipVertical =
        !this.previewItem.currentVariation.flipVertical;
      this.changeCheckedItems({
        isFlip: true,
      });
      this.$store.commit("addNewStateToHistory");
    },
    getFileOutputSize() {
      return this.previewItem.currentVariation.getFileOutputSizeMb();
    },
    onChangeFileOutputBitrate(fileOutputBitrate) {
      this.previewItem.currentVariation.fileOutputParameters.bitrate =
        fileOutputBitrate;
    },
    changeCheckedItems(optionsToChange) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }

          if (!!optionsToChange.isImage) {
            v.backgroundImage = {
              ...this.previewItem.currentVariation.backgroundImage,
            };
          }

          if (!!optionsToChange.isColor) {
            v.backgroundColor =
              this.previewItem.currentVariation.backgroundColor;
          }

          if (
            !!optionsToChange.isPreset &&
            !v.parentItem.isForSlice &&
            !(v.currentSize.title === "Original") &&
            !(
              v.parentItem.isOutsize &&
              this.previewItem.currentVariation.preset.name === "tile"
            )
          ) {
            v.preset = Item.presets.find(
              (preset) =>
                preset.name === this.previewItem.currentVariation.preset.name
            );
            if (this.previewItem.currentVariation.preset.name === "color") {
              v.backgroundColor =
                this.previewItem.currentVariation.backgroundColor;
            }
            v.calcVideoPreviewPositon(v.preset.name);
          }
          if (!!optionsToChange.isSize) {
            let itemSizes = item.getVideoSizes(
              item.isForSlice ? null : item.inputSize.name,
              !item.isForSlice
            );
            v.currentSize = itemSizes.find((size) => {
              if (
                (this.isOriginalSize ||
                  this.previewItem.currentVariation.currentSize.name ===
                    item.inputSize.name) &&
                !v.parentItem.isForSlice
              ) {
                return size.title === "Original";
              } else {
                return (
                  size.name ===
                  this.previewItem.currentVariation.currentSize.name
                );
              }
            });
            v.previewParameters.userOuterVideoResolutionsDifference =
              this.previewItem.currentVariation.previewParameters.userOuterVideoResolutionsDifference;
            setTimeout(() => {
              v.previewParameters.checkAndUpdateUserOuterVideoResolutions();
              v.recalcFileOutputParameters();
            }, 10);
            /*  v.currentSize = Item.videoSizes.find(
              (size) =>
                size.name === this.previewItem.currentVariation.currentSize.name
            ); */
          }
          if (!!optionsToChange.isMetadata) {
            v.isRemoveMetadata =
              this.previewItem.currentVariation.isRemoveMetadata;
          }
          if (!!optionsToChange.isStrictMaxSize) {
            v.fileOutputParameters.isStrictMaxSize =
              this.previewItem.currentVariation.fileOutputParameters.isStrictMaxSize;
            v.recalcFileOutputParameters();
          }
          if (!!optionsToChange.isFlip) {
            v.flipHorizontal = this.previewItem.currentVariation.flipHorizontal;
            v.flipVertical = this.previewItem.currentVariation.flipVertical;
          }
          if (!!optionsToChange.isShift && !this.isVideoShiftsDisabled(v)) {
            if (v.previewParameters.maxHorizontalShift !== 0) {
              v.previewParameters.displayHorizontalShift =
                this.previewItem.currentVariation.previewParameters.displayHorizontalShift;
              v.previewParameters.horizontalShift =
                v.getShiftByDisplayShift(true);
            }
            if (v.previewParameters.maxVerticalShift !== 0) {
              v.previewParameters.displayVerticalShift =
                this.previewItem.currentVariation.previewParameters.displayVerticalShift;
              v.previewParameters.verticalShift =
                v.getShiftByDisplayShift(false);
            }
            v.shiftVideoPreview(
              v.previewParameters.horizontalShift,
              v.previewParameters.verticalShift
            );
          }
          if (!!optionsToChange.isZoom && v.preset.name !== "tile") {
            v.previewParameters.zoom =
              this.previewItem.currentVariation.previewParameters.zoom;
            v.calcVideoPreviewPositon(v.preset.name);
            v.recalcCropsParams(this.$store.getters.videoPreviewPixelsWidth);
          }
          if (!!optionsToChange.isSharp) {
            v.isSharpEnabled = this.previewItem.currentVariation.isSharpEnabled;
          }
          v.recalcOuterVideoResolutions();
        });
      });
    },
    setBackgroundColor(color) {
      this.previewItem.currentVariation.backgroundColor = color;
      this.changeCheckedItems({
        isPreset: true,
        isColor: true,
      });
    },
    onClickImageButton(buttonName, file?) {
      if (buttonName === "+") {
        (<HTMLElement>this.$refs.fileInput).click();
        return;
      } else if (buttonName === "file") {
        this.previewItem.currentVariation.backgroundImage = { ...file };
        this.changeCheckedItems({
          isImage: true,
        });
      }
    },
    isImageFileSelected(buttonName, file?) {
      return (
        this.previewItem.currentVariation.backgroundImage &&
        buttonName === "file" &&
        file.id === this.previewItem.currentVariation.backgroundImage.id
      );
    },
    onDeleteFile(file) {
      let isDelete = window.confirm("Are you sure to delete image?");
      if (!isDelete) {
        return;
      }
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      let route = "/bg/remBG";
      this.axios
        .post(
          route,
          { id: file.id, sessionId: this.$store.state.userInfo.sessionId },
          config
        )
        .then((res) => {
          if (this.isImageFileSelected("file", file)) {
            let defaultFile = this.imageFiles.find((f) => f.id === 1);
            this.onClickImageButton("file", defaultFile);
          }
          let indexToDelete = this.imageFiles.indexOf(file);
          this.imageFiles.splice(indexToDelete, 1);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onFileChanged(event: any) {
      let imageFiles: FileList = event.target.files;
      this.validateAndUploadImageFiles(imageFiles);
      event.target.value = "";
    },
    validateAndUploadImageFiles(imageFiles) {
      let result: File[] = [];
      const maxCount = 10;
      let maxIndex =
        imageFiles.length > maxCount ? maxCount : imageFiles.length;
      for (var i = 0; i < maxIndex; i++) {
        result.push(<File>imageFiles.item(i));
      }
      this.uploadImageFiles(result);
    },
    uploadImageFiles(imageFiles: File[]) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let data = new FormData();
      for (var i = 0; i < imageFiles.length; i++) {
        let file = imageFiles[i];
        data.append("files[" + i + "]", file);
      }
      data.append("sessionId", this.$store.state.userInfo.sessionId);

      let route = "/bg/filesUploadMulti";
      this.axios
        .post(route, data, config)
        .then((res) => {
          res.data.forEach((file) => {
            this.imageFiles.unshift({
              id: file.id,
              path: file.path,
              w: file.w,
              h: file.h,
            });
          });
          let defaultFile = this.imageFiles.find((f) => f.id === 1);
          let indexToDelete = this.imageFiles.indexOf(defaultFile);
          this.imageFiles.splice(indexToDelete, 1);
          this.imageFiles.unshift(defaultFile);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isVideoShiftsDisabled(variation) {
      let isOriginalSize = variation.currentSize.title === "Original";
      return (
        (isOriginalSize && variation.parentItem.isOutsize) ||
        (!isOriginalSize && variation.preset.name === "tile")
      );
    },
  },
});
